import { materialProgramInputs } from '../materialProgramInputs';
export const wireGizmoProgram = (color, opacity = 1) => materialProgramInputs({
    props: { color, wireframe: true, ...(opacity < 1 ? { opacity, transparent: true } : {}) },
});
//# sourceMappingURL=wireGizmoProgram.js.map